module.exports = __webpack_public_path__ + "static/media/9C.ba5ca4db.svg";